import { JOURNAL_BRIEF_TAB_INDEX } from "../game/journal-tab-indices.js";

export function briefSeenStorageKey(sessionId: string): string {
  return `ccc_brief_${sessionId}`;
}

export function hasSeenCaseBrief(sessionId: string, storage: Storage | null): boolean {
  if (!sessionId || !storage) return false;
  return storage.getItem(briefSeenStorageKey(sessionId)) !== null;
}

/** Persist brief-seen only when the player closes the Brief tab after an auto-opened first brief. */
export function shouldPersistBriefSeenOnJournalClose(opts: {
  activeTab: number;
  briefTabIndex?: number;
  awaitingDismissPersist: boolean;
  fromMirror: boolean;
  sessionId: string;
}): boolean {
  const briefTab = opts.briefTabIndex ?? JOURNAL_BRIEF_TAB_INDEX;
  return (
    opts.activeTab === briefTab &&
    opts.awaitingDismissPersist &&
    Boolean(opts.sessionId) &&
    !opts.fromMirror
  );
}
